export const Navbar = () => {
  return (
    <div className="text-cWhite font-semibold text-center pt-14 select-none">מִי לֹא מְפַחֵד כָּמוֹנִי מֵהָאַזְעָקָה?</div>
  )
}
